import { AddedFrom, Contractor } from "@/api/williams/contractors";
import { ContractorForm } from "./ContractorForm";
import { v4 as uuid } from "uuid";

export function CreateContractor() {
  const defaultValues: Contractor = {
    id: uuid(),
    name: "",
    regions: [],
    creationDate: new Date(),
    addedFrom: AddedFrom.Waypoint,
  };

  return <ContractorForm data={defaultValues} />;
}
